import styled from "styled-components"
import theme from "../theme"

const ToggleSwitch = styled<any, "input">("input")`
  position: relative;
  margin-left: 10%;
  appearance: none;
  outline: none;
  width: 50px;
  height: 30px;
  background-color: #ffffff;
  border: 1px solid #d1d3d4;
  border-radius: 50px;
  box-shadow: inset -20px 0 0 0 #d1d3d4;
  transition-duration: 200ms;
  &:after {
    content: "";
    position: absolute;
    top: 1px;
    left: 1px;
    width: 26px;
    height: 26px;
    background-color: transparent;
    border-radius: 50%;
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
  }
  &:checked {
    border-color: ${theme.colors.success};
    box-shadow: inset 20px 0 0 0 ${theme.colors.success};
  }
  &:checked:after {
    left: 20px;
    box-shadow: -2px 4px 3px rgba(0, 0, 0, 0.05);
  }
`

export default ToggleSwitch
